<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <SellProductFiltersComponent
                    ref="sell-product-search"
                    @searchPressed="filterSellData"
                ></SellProductFiltersComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col md="4" sm="5" xs="12">
                                <v-select
                                    :items="shopList"
                                    v-model="selectedShop"
                                    label="Negozio"
                                    item-text="description"
                                    item-value="id"
                                    return-object
                                    @change="onChangeShop()"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="selectedShop && selectedShop.plant_image != null">
            <v-col>
                <LMap
                    style="
                        width: '100%';
                        height: 650px;
                        margin: 0 auto;
                        border: 1px solid black;
                    "
                    :minZoom="minZoom"
                    :crs="crs"
                    :center="[selectedShop.height / 2, selectedShop.width / 2]"
                    :options="{
                        doubleClickZoom: false,
                    }"
                    @dblclick="onMapDblClick"
                >
                    <LImageOverlay
                        :url="selectedShop.plant_image"
                        :bounds="[
                            [0, 0],
                            [selectedShop.height, selectedShop.width],
                        ]"
                    ></LImageOverlay>
                    <LMarker
                        v-for="(m, index) in markers"
                        :key="index"
                        :lat-lng="[m.lat, m.lng]"
                        note
                        @click="onMarkerClick(m)"
                    >
                        <LIcon
                            iconUrl="/marker-icon.png"
                            shadowUrl="/marker-shadow.png"
                        >
                        </LIcon>
                        <LTooltip
                            ><ToolTipProductList
                                :products="getProductByShop(m.rack_id)"
                                :marker="m"
                            ></ToolTipProductList
                        ></LTooltip>
                    </LMarker>
                </LMap>
            </v-col>
        </v-row>
        <v-dialog v-model="overlay" style="z-index: 9999" max-width="50%">
            <CreatePointModal
                ref="createPointModal"
                :racks="availableRacks"
                :open="overlay"
                @closeDialog="overlay = false"
                @onSave="onSave"
                @deleted="onDeleteMarker"
            ></CreatePointModal>
        </v-dialog>
        <v-dialog
            ref="dialog"
            v-model="modal"
            style="z-index: 9999"
            persistent
            width="290px"
        >
            <v-date-picker v-model="filters.date_range" scrollable range>
                <v-btn text color="primary" @click="modal = false"> OK </v-btn>
            </v-date-picker>
        </v-dialog>
    </v-container>
</template>
<script>
import L from "leaflet";
import SellProductFiltersComponent from "../../../components/SellProductFiltersComponent.vue";
import ToolTipProductList from "../components/ToolTipProductList.vue";
import {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LIcon,
    LTooltip,
} from "vue2-leaflet";
import CreatePointModal from "../modals/CreatePointModal.vue";
import requests from "../../../requests";

export default {
    name: "racks-maps-list",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LImageOverlay,
        LIcon,
        CreatePointModal,
        LTooltip,
        SellProductFiltersComponent,
        ToolTipProductList,
    },
    computed: {
        availableRacks() {
            let racks = this.racklist.filter((r) => {
                return !this.markers.find((m) => m.rack_id == r.id);
            });
            racks.push(this.currentRack);
            return racks;
        },
    },
    data() {
        return {
            markers: [],
            minZoom: -2,
            maxZoom: 12,
            crs: L.CRS.Simple,
            selectedShop: null,
            shopList: [],
            overlay: false,
            racklist: [],
            hideMap: false,
            currentRack: null,
            coord: {
                lat: 0,
                lng: 0,
            },
            modal: false,
            shopSells: {},
            periods: [
                {
                    id: "last_week",
                    description: "Ultima settimana",
                },
                {
                    id: "last_month",
                    description: "Ultimo mese",
                },
                {
                    id: "last_three_months",
                    description: "Ultimi 3 mesi",
                },
                {
                    id: "last_six_months",
                    description: "Ultimi 6 mesi",
                },
                {
                    id: "last_year",
                    description: "Ultimo anno",
                },
                {
                    id: "custom",
                    description: "Custom",
                },
            ],
            filters: {
                period: null,
                date_range: [],
            },
        };
    },

    mounted() {
        this.getShopList();
    },

    methods: {
        getShopList() {
            requests.getShopList().then((res) => {
                this.selectedShop = res.data[0];
                this.shopList = res.data;

                const filters = this.$refs["sell-product-search"].getFilters();
                this.getShopRackSell(filters);
                this.getRackByShop(this.selectedShop.id);
                this.getPointsByShop(this.selectedShop.id);
            });
        },
        onMapDblClick(e) {
            this.overlay = true;
            this.coord.lat = e.latlng.lat;
            this.coord.lng = e.latlng.lng;
        },
        onSave(rack, note, markerId) {
            let d = {
                shop_id: this.selectedShop.id,
                rack_id: rack.id,
                latitude: this.coord.lat,
                longitude: this.coord.lng,
                note: note,
                marker_id: markerId,
            };
            requests.createShopMarker(d).then((res) => {
                this.getRackByShop(this.selectedShop.id);
                this.coord.lat = 0;
                this.coord.lng = 0;
                this.overlay = false;
                this.getPointsByShop();
            });
        },
        getRackByShop(shopId) {
            requests.getRackByShop(shopId).then((res) => {
                this.racklist = res.data;
            });
        },
        onChangeShop() {
            this.getRackByShop(this.selectedShop.id);
            this.getPointsByShop();
            const filters = this.$refs["sell-product-search"].getFilters();
            this.getShopRackSell(filters);
        },
        getPointsByShop() {
            requests.getPointsByShop(this.selectedShop.id).then((res) => {
                this.markers = res.data;
            });
        },
        onMarkerClick(m) {
            this.currentRack = m.rack;
            this.coord.lat = m.lat;
            this.coord.lng = m.lng;
            this.overlay = true;
            this.$nextTick(() => {
                this.$refs.createPointModal.loadMarker(
                    m.id,
                    this.getProductByShop(m.rack_id)
                );
            });
        },
        onDeleteMarker() {
            this.getPointsByShop();
            this.overlay = false;
        },
        onChangePeriod() {
            if (this.filters.period == "custom") this.modal = true;
        },
        filterData() {
            //TODO: filtrare i dati per le vendite
            console.log();
        },
        filterSellData(filterData) {
            this.getShopRackSell(filterData);
        },
        getShopRackSell(filterData) {
            requests
                .getShopRackSell(this.selectedShop.id, filterData)
                .then((res) => {
                    this.shopSells = res.data.data;
                });
        },

        getProductByShop(rackId) {
            if (!_.isUndefined(this.shopSells[rackId])) {
                return this.shopSells[rackId];
            }
            return [];
        },
    },
};
</script>
<style scope lang="scss">
.v-menu__content {
    z-index: 10003 !important;
}
</style>
